import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { BulkSelfAssessment } from 'src/app/core/models/self-assessment/self-assessment';
import {
  SelfAssessmentAllDropdownList,
  SelfAssessmentDetailsDD,
  SelfAssessmentT2AllDropdownList,
  SelfAssessmentT2DetailsDD,
} from 'src/app/core/models/self-assessment/self-assessment-details-dd';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { UserProfile } from 'src/app/core/models/user';
import { Role } from 'src/app/core/models/user-management/role';
import { ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { GDPRService } from 'src/app/core/services/rulebook';
import { MasterHelper } from 'src/app/core/utilities';
//import * as customBuild from './../../../../ckCustomeBuild/build/ckeditor';
import { BulkSelfAssessmentT2, ConfirmApprove } from 'src/app/core/models/self-assessmentT2/self-assessmentT2';

@Component({
  selector: 'app-bulk-self-update-dialog',
  templateUrl: './bulk-self-update-dialog.component.html',
  styleUrls: ['./bulk-self-update-dialog.component.scss'],
})
export class BulkSelfUpdateDialogComponent implements OnInit {
  toastModel: ToastViewModel;
  isToastShow = false;
  selfAssessment: BulkSelfAssessment;
  selfAssessmentNew: BulkSelfAssessmentT2;
  selfAssessmentDD: SelfAssessmentDetailsDD;
  selfAssessmentT2DD: SelfAssessmentT2DetailsDD;
  selfAssessmentDocument: Array<SelfAssessmentDocumentModel>;
  //public Editor = customBuild;
  selfAssessmentAllDropdownList: SelfAssessmentAllDropdownList;
  selfAssessmentT2AllDropdownList: SelfAssessmentT2AllDropdownList;
  assessorDD: string[] = [];
  assessorDelDD: string[] = [];
  reviewerDD: string[] = [];
  reviewerDelDD: string[] = [];
  actOwnerDD: string[] = [];
  enhmtActOwnerDD: string[] = [];

  searchedAssessor: FilterViewModel[] = [];
  searchedAssessorDel: FilterViewModel[] = [];
  searchedReviewer: FilterViewModel[] = [];
  searchedReviewerDel: FilterViewModel[] = [];
  searchedActOwner: FilterViewModel[] = [];
  searchedEnhmtActOwner: FilterViewModel[] = [];

  separatorKeysCodes: number[] = [ENTER, COMMA];
  isLoadingFilters = false;
  searchAssessorCntrl: FormControl = new FormControl();
  searchAssessorDelCntrl: FormControl = new FormControl();
  searchReviewerCntrl: FormControl = new FormControl();
  searchReviewerDelCntrl: FormControl = new FormControl();
  searchActOwnerCntrl: FormControl = new FormControl();
  searchEnhmtActOwnerCntrl: FormControl = new FormControl();

  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;

  @ViewChild('assessorDelInput')
  assessorDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorDelAutocomplete')
  assessorDelAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete')
  reviewerAutocomplete!: MatAutocomplete;

  @ViewChild('reviewerDelInput')
  reviewerDelInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerDelAutocomplete')
  reviewerDelAutocomplete!: MatAutocomplete;

  @ViewChild('actOwnerInput')
  actOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('actOwnerAutocomplete')
  actOwnerAutocomplete!: MatAutocomplete;

  @ViewChild('enhmtActOwnerInput')
  enhmtActOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('enhmtActOwnerAutocomplete')
  enhmtActOwnerAutocomplete!: MatAutocomplete;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  ruleApplicable: Array<string> = ['Yes', 'No'];

  assessmentStatus: Array<string> = [];
  reviewStatus: Array<string> = [];
  overallStatus: Array<string> = [];
  ruleConclusion: Array<string> = [];
  gapReviewStatus: Array<string> = [];
  actionStatus: Array<string> = [];
  enhancementReviewStatus: Array<string> = [];
  enhancementActionStatus: Array<string> = [];
  currentUserRole = '';
  user: UserProfile;
  isSADetails1 = false;
  isSADetails2 = false;
  isSADetails3 = false;
  isSADetails4 = false;
  isSADetails5 = false;
  isSADetails6 = false;
  isSADetails7 = false;
  isSADetails8 = false;
  isLoadingDD = false;

  templateNo = 1;
  divisionId!: number;

  //New variables for New Self Assessment Template (2)
  assessorDD2: string[] = [];
  reviewerDD2: string[] = [];
  approverDD2: string[] = [];

  searchedAssessor2: FilterViewModel[] = [];
  searchedApprover2: FilterViewModel[] = [];
  searchedReviewer2: FilterViewModel[] = [];

  searchAssessorCntrl2: FormControl = new FormControl();
  searchApproverCntrl2: FormControl = new FormControl();
  searchReviewerCntrl2: FormControl = new FormControl();

  @ViewChild('assessorInput2')
  assessorInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('assessorAutocomplete2')
  assessorAutocomplete2!: MatAutocomplete;

  @ViewChild('approverInput2')
  approverInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('approverAutocomplete2')
  approverAutocomplete2!: MatAutocomplete;

  @ViewChild('reviewerInput2')
  reviewerInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete2')
  reviewerAutocomplete2!: MatAutocomplete;

  assessmentCategory2: Array<string> = [];
  assessmentTeam2: Array<string> = [];
  assessmentStatus2: Array<string> = [];
  complianceStatus2: Array<string> = [];
  interpretations2: Array<string> = [];
  judgement2: Array<string> = [];
  gaps2: Array<string> = [];
  enhancement2: Array<string> = [];
  riskRecommendation2: Array<string> = [];
  riskRecommendationStatus2: Array<string> = [];
  approvalStatus2: Array<string> = [];
  confirmApproval2: ConfirmApprove[] = [];
  reviewerTeam2: Array<string> = [];
  approvalTeam2: Array<string> = [];
  reviewStatus2: Array<string> = [];

  isSA2Details1 = false;
  isSA2Details2 = false;
  isSA2Details3 = false;
  isSA2Details4 = false;
  isSA2Details5 = false;
  isSA2Details6 = false;
  isSA2Details7 = false;
  selectedItems: number[] = [];
  constructor(
    private gdprService: GDPRService,
    private sessionService: SessionService,
    public dialogRef: MatDialogRef<BulkSelfUpdateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.selectedItems = data.selectedItems;
    this.toastModel = new ToastViewModel();
    this.selfAssessment = new BulkSelfAssessment();
    this.selfAssessmentNew = new BulkSelfAssessmentT2();
    this.selfAssessmentDD = new SelfAssessmentDetailsDD();
    this.selfAssessmentT2DD = new SelfAssessmentT2DetailsDD();
    this.selfAssessmentDocument = [];
    this.selfAssessmentAllDropdownList = new SelfAssessmentAllDropdownList();
    this.selfAssessmentT2AllDropdownList = new SelfAssessmentT2AllDropdownList();
    this.user = new UserProfile();
  }

  ngOnInit(): void {
    this.divisionId = JSON.parse(this.fetchFromBrowser("selectedDivision") as string);
    this.gdprService.getSelfAssessmentTemplate(this.divisionId).subscribe((templateNo: number) => {
      this.templateNo = templateNo;
      this.getUserProfile();
      this.fetchSelfAssessmentDD();
      this.fetchSelfAssessmentAllDropdownList();
    });
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }

  fetchSelfAssessmentAllDropdownList(): void {
    this.isLoadingDD = true;
    if (this.templateNo == 2) {
      this.gdprService
        .getSelfAssessmentT2AllDropdownList()
        .subscribe((result: SelfAssessmentT2AllDropdownList) => {
          this.isLoadingDD = false;
          this.selfAssessmentT2AllDropdownList = result;
          this.assessmentStatus2 = this.selfAssessmentT2AllDropdownList.assessmentStatus;
          this.reviewStatus2 = this.selfAssessmentT2AllDropdownList.reviewStatus;
          this.assessmentCategory2 = this.selfAssessmentT2AllDropdownList.assessmentCategory;
          this.assessmentTeam2 = this.selfAssessmentT2AllDropdownList.assessmentTeam;
          this.complianceStatus2 = this.selfAssessmentT2AllDropdownList.complianceStatus;
          this.interpretations2 = this.selfAssessmentT2AllDropdownList.interpretation;
          this.judgement2 = this.selfAssessmentT2AllDropdownList.judgement;
          this.gaps2 = this.selfAssessmentT2AllDropdownList.gaps;
          this.enhancement2 = this.selfAssessmentT2AllDropdownList.enhancement;
          this.riskRecommendation2 = this.selfAssessmentT2AllDropdownList.riskRecommendation;
          this.riskRecommendationStatus2 = this.selfAssessmentT2AllDropdownList.riskRecommendationStatus;
          this.reviewerTeam2 = this.selfAssessmentT2AllDropdownList.reviewerTeam;
          this.approvalTeam2 = this.selfAssessmentT2AllDropdownList.approvalTeam;
          this.approvalStatus2 = this.selfAssessmentT2AllDropdownList.approvalStatus;
        });
    }
    else {
      this.gdprService
        .getSelfAssessmentAllDropdownList()
        .subscribe((result: SelfAssessmentAllDropdownList) => {
          this.isLoadingDD = false;
          this.selfAssessmentAllDropdownList = result;
          this.assessmentStatus =
            this.selfAssessmentAllDropdownList.assessmentStatus;
          this.reviewStatus = this.selfAssessmentAllDropdownList.reviewStatus;
          this.overallStatus = this.selfAssessmentAllDropdownList.overallStatus;
          this.ruleConclusion = this.selfAssessmentAllDropdownList.ruleConclusion;
          this.gapReviewStatus =
            this.selfAssessmentAllDropdownList.gapReviewStatus;
          this.actionStatus = this.selfAssessmentAllDropdownList.actionStatus;
          this.enhancementReviewStatus =
            this.selfAssessmentAllDropdownList.enhancementReviewStatus;
          this.enhancementActionStatus =
            this.selfAssessmentAllDropdownList.enhancementActionStatus;
        });
    }
  }

  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((user: UserProfile) => {
      this.user = user;
      // this.user.externalUserId
      if (this.user && this.user.roleId > 0) {
        this.fetchCurrentUserRole();
      }
    });
  }

  fetchCurrentUserRole(): void {
    this.gdprService
      .getCurrentUserRole(this.user.roleId)
      .subscribe((data: Role) => {
        this.currentUserRole = data.title;
      });
  }

  fetchSelfAssessmentDD(): void {
    this.isLoadingDD = true;
    if (this.templateNo == 2) {
      this.gdprService
        .GetSelfAssessmentT2DD()
        .subscribe((result: SelfAssessmentT2DetailsDD) => {
          this.isLoadingDD = false;
          this.selfAssessmentT2DD = result;
          this.ddListData();
          // this.selectedDDvalue();
        });
    }
    else {
      this.gdprService
        .getSelfAssessmentDD()
        .subscribe((result: SelfAssessmentDetailsDD) => {
          this.isLoadingDD = false;
          this.selfAssessmentDD = result;
          this.ddListData();
          // this.selectedDDvalue();
        });
    }
  }

  ddListData(): void {
    if (this.templateNo == 2) {
      this.searchedAssessor2 = this.selfAssessmentT2DD.assessor;
      this.searchedReviewer2 = this.selfAssessmentT2DD.reviewer;
      this.searchedApprover2 = this.selfAssessmentT2DD.approver;
    }
    else {
      this.searchedAssessor = this.selfAssessmentDD.assessor;
      this.searchedAssessorDel = this.selfAssessmentDD.assessorDelegate;
      this.searchedReviewer = this.selfAssessmentDD.reviewer;
      this.searchedReviewerDel = this.selfAssessmentDD.reviewerDelegate;
      this.searchedActOwner = this.selfAssessmentDD.actionOwner;
      this.searchedEnhmtActOwner = this.selfAssessmentDD.enhancementActionOwner;
    }
  }

  // selectedDDvalue(): void {
  //   this.assessorDD = this.selfAssessment.assessor
  //     ? this.selfAssessment.assessor.split(',')
  //     : this.assessorDD;
  //   this.assessorDelDD = this.selfAssessment.assessorDelegate
  //     ? this.selfAssessment.assessorDelegate.split(',')
  //     : this.assessorDelDD;
  //   this.reviewerDD = this.selfAssessment.reviewer
  //     ? this.selfAssessment.reviewer.split(',')
  //     : this.reviewerDD;
  //   this.reviewerDelDD = this.selfAssessment.reviewerDelegate
  //     ? this.selfAssessment.reviewerDelegate.split(',')
  //     : this.reviewerDelDD;
  //   this.actOwnerDD = this.selfAssessment.actionOwner
  //     ? this.selfAssessment.actionOwner.split(',')
  //     : this.actOwnerDD;
  //   this.enhmtActOwnerDD = this.selfAssessment.enhancementActionOwner
  //     ? this.selfAssessment.enhancementActionOwner.split(',')
  //     : this.enhmtActOwnerDD;
  // }

  // Assessor multiselect
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessor(event: MatChipInputEvent): void {
    if (!this.assessorAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
    }
  }

  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
    }
    this.assessorInput.nativeElement.value = '';
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
  }

  removeAssessor(status: string): void {
    const index = (this.assessorDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD as string[]).splice(index, 1);
    }
  }

  // Assessor Delegate multiselect
  filterAssessorDelegate(search: string): any {
    return this.searchedAssessorDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessorDelegate(event: MatChipInputEvent): void {
    if (!this.assessorDelAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.assessorDelDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDelDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchAssessorDelCntrl.setValue(null);
    }
  }

  selectedAssessorDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDelDD) {
      let sameValueRow = this.assessorDelDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDelDD.push(event.option.viewValue);
      }
    } else {
      this.assessorDelDD = [];
      this.assessorDelDD.push(event.option.viewValue);
    }
    this.assessorDelInput.nativeElement.value = '';
    this.searchAssessorDelCntrl.setValue(null);
    this.searchAssessorDelCntrl.disable();
    this.searchAssessorDelCntrl.enable();
  }

  removeAssessorDelegate(status: string): void {
    const index = (this.assessorDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDelDD as string[]).splice(index, 1);
    }
  }

  // Reviewer multiselect
  filterReviewer(search: string): any {
    return this.searchedReviewer.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewer(event: MatChipInputEvent): void {
    if (!this.reviewerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchReviewerCntrl.setValue(null);
    }
  }

  selectedReviewerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD) {
      let sameValueRow = this.reviewerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDD.push(event.option.viewValue);
      }
    } else {
      this.reviewerDD = [];
      this.reviewerDD.push(event.option.viewValue);
    }
    this.reviewerInput.nativeElement.value = '';
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
  }

  removeReviewer(status: string): void {
    const index = (this.reviewerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD as string[]).splice(index, 1);
    }
  }

  // Reviewer Delegate multiselect
  filterReviewerDelegate(search: string): any {
    return this.searchedReviewerDel.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewerDelegate(event: MatChipInputEvent): void {
    if (!this.reviewerDelAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDelDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDelDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchReviewerDelCntrl.setValue(null);
    }
  }

  selectedReviewerDelegateEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDelDD) {
      let sameValueRow = this.reviewerDelDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDelDD.push(event.option.viewValue);
      }
    } else {
      this.reviewerDelDD = [];
      this.reviewerDelDD.push(event.option.viewValue);
    }
    this.reviewerDelInput.nativeElement.value = '';
    this.searchReviewerDelCntrl.setValue(null);
    this.searchReviewerDelCntrl.disable();
    this.searchReviewerDelCntrl.enable();
  }

  removeReviewerDelegate(status: string): void {
    const index = (this.reviewerDelDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDelDD as string[]).splice(index, 1);
    }
  }

  // Action Owner multiselect
  filterActionOwner(search: string): any {
    return this.searchedActOwner.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addActionOwner(event: MatChipInputEvent): void {
    if (!this.actOwnerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.actOwnerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.actOwnerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchActOwnerCntrl.setValue(null);
    }
  }

  selectedActionOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.actOwnerDD) {
      let sameValueRow = this.actOwnerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.actOwnerDD.push(event.option.viewValue);
      }
    } else {
      this.actOwnerDD = [];
      this.actOwnerDD.push(event.option.viewValue);
    }
    this.actOwnerInput.nativeElement.value = '';
    this.searchActOwnerCntrl.setValue(null);
    this.searchActOwnerCntrl.disable();
    this.searchActOwnerCntrl.enable();
  }

  removeActionOwner(status: string): void {
    const index = (this.actOwnerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.actOwnerDD as string[]).splice(index, 1);
    }
  }

  // Enhancement Action Owner multiselect
  filterEnhmtActionOwner(search: string): any {
    return this.searchedEnhmtActOwner.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addEnhmtActionOwner(event: MatChipInputEvent): void {
    if (!this.enhmtActOwnerAutocomplete.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.enhmtActOwnerDD.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.enhmtActOwnerDD as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchEnhmtActOwnerCntrl.setValue(null);
    }
  }

  selectedEnhmtActionOwnerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.enhmtActOwnerDD) {
      let sameValueRow = this.enhmtActOwnerDD.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.enhmtActOwnerDD.push(event.option.viewValue);
      }
    } else {
      this.enhmtActOwnerDD = [];
      this.enhmtActOwnerDD.push(event.option.viewValue);
    }
    this.enhmtActOwnerInput.nativeElement.value = '';
    this.searchEnhmtActOwnerCntrl.setValue(null);
    this.searchEnhmtActOwnerCntrl.disable();
    this.searchEnhmtActOwnerCntrl.enable();
  }

  removeEnhmtActionOwner(status: string): void {
    const index = (this.enhmtActOwnerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.enhmtActOwnerDD as string[]).splice(index, 1);
    }
  }

  updateSelfAssessment() {
    if (this.templateNo == 2) {
      this.selfAssessmentNew.assessor = this.assessorDD2.toString();
      this.selfAssessmentNew.approvers = this.approverDD2.toString();
      this.selfAssessmentNew.reviewer = this.reviewerDD2.toString();
      if (this.confirmApproval2 != null) {
        this.selfAssessmentNew.confirmApproval = JSON.stringify(this.confirmApproval2);
      }
      this.selfAssessmentNew.assessmentDueDate = this.selfAssessmentNew
        .assessmentDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessmentNew.assessmentDueDate.toString()
        )
        : null;
      this.selfAssessmentNew.gapActionDueDate = this.selfAssessmentNew
        .gapActionDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessmentNew.gapActionDueDate.toString()
        )
        : null;
      this.selfAssessmentNew.riskRecommendationDueDate = this.selfAssessmentNew
        .riskRecommendationDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessmentNew.riskRecommendationDueDate.toString()
        )
        : null;
      this.dialogRef.close(this.selfAssessmentNew);
    }
    else {
      this.selfAssessment.assessor = this.assessorDD.toString();
      this.selfAssessment.assessorDelegate = this.assessorDelDD.toString();
      this.selfAssessment.reviewer = this.reviewerDD.toString();
      this.selfAssessment.reviewerDelegate = this.reviewerDelDD.toString();
      this.selfAssessment.actionOwner = this.actOwnerDD.toString();
      this.selfAssessment.enhancementActionOwner = this.actOwnerDD.toString();
      this.selfAssessment.assessmentDueDate = this.selfAssessment
        .assessmentDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessment.assessmentDueDate.toString()
        )
        : null;
      this.selfAssessment.reviewDueDate = this.selfAssessment.reviewDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessment.reviewDueDate.toString()
        )
        : null;
      this.selfAssessment.actionDueDate = this.selfAssessment.actionDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessment.actionDueDate.toString()
        )
        : null;
      this.selfAssessment.enhancementActionDueDate = this.selfAssessment
        .enhancementActionDueDate
        ? MasterHelper.bsdatePickerToCorrectDate(
          this.selfAssessment.enhancementActionDueDate.toString()
        )
        : null;
      this.dialogRef.close(this.selfAssessment);
    }
  }
  //For New Self Assessment
  //Approver Multiselect
  filterApprover2(search: string): any {
    return this.searchedApprover2.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  addApprover2(event: MatChipInputEvent): void {
    if (!this.approverAutocomplete2.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.approverDD2.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.approverDD2 as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchApproverCntrl2.setValue(null);
    }
  }
  selectedApproverEvent2(event: MatAutocompleteSelectedEvent): void {
    if (this.approverDD2) {
      let sameValueRow = this.approverDD2.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.approverDD2.push(event.option.viewValue);
        this.confirmApproval2.push({ approverName: event.option.viewValue, isConfirmed: false });
        let countOfApprover = this.confirmApproval2.length;
        let countConfirmed = this.confirmApproval2.filter(approval => approval.isConfirmed).length;
        if (countConfirmed > 0) {
          this.selfAssessmentNew.approvalStatus = "Approved (" + countConfirmed + " of " + countOfApprover + ")";
        }
        else {
          this.selfAssessmentNew.approvalStatus = "Not started";
        }
      }
    } else {
      this.approverDD2 = [];
      this.approverDD2.push(event.option.viewValue);
      this.confirmApproval2.push({ approverName: event.option.viewValue, isConfirmed: false });
      let countOfApprover = this.confirmApproval2.length;
      let countConfirmed = this.confirmApproval2.filter(approval => approval.isConfirmed).length;
      if (countConfirmed > 0) {
        this.selfAssessmentNew.approvalStatus = "Approved (" + countConfirmed + " of " + countOfApprover + ")";
      }
      else {
        this.selfAssessmentNew.approvalStatus = "Not started";
      }
    }
    this.approverInput2.nativeElement.value = '';
    this.searchApproverCntrl2.setValue(null);
    this.searchApproverCntrl2.disable();
    this.searchApproverCntrl2.enable();
  }
  removeApprover2(status: string): void {
    const index = (this.approverDD2 as string[]).indexOf(status);

    if (index >= 0) {
      this.confirmApproval2.splice(index, 1);
      let countOfApprover = this.confirmApproval2.length;
      let countConfirmed = this.confirmApproval2.filter(approval => approval.isConfirmed).length;
      if (countConfirmed > 0) {
        this.selfAssessmentNew.approvalStatus = "Approved (" + countConfirmed + " of " + countOfApprover + ")";
      }
      else {
        this.selfAssessmentNew.approvalStatus = "Not started";
      }
      (this.approverDD2 as string[]).splice(index, 1);
    }
  }
  // Assessor multiselect
  filterAssessor2(search: string): any {
    return this.searchedAssessor2.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addAssessor2(event: MatChipInputEvent): void {
    if (!this.assessorAutocomplete2.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD2.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.assessorDD2 as string[]).push(value);
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl2.setValue(null);
    }
  }

  selectedAssessorEvent2(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD2) {
      let sameValueRow = this.assessorDD2.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.assessorDD2.push(event.option.viewValue);
      }
    } else {
      this.assessorDD2 = [];
      this.assessorDD2.push(event.option.viewValue);
    }
    this.assessorInput2.nativeElement.value = '';
    this.searchAssessorCntrl2.setValue(null);
    this.searchAssessorCntrl2.disable();
    this.searchAssessorCntrl2.enable();
  }

  removeAssessor2(status: string): void {
    const index = (this.assessorDD2 as string[]).indexOf(status);

    if (index >= 0) {
      (this.assessorDD2 as string[]).splice(index, 1);
    }
  }

  // Reviewer multiselect
  filterReviewer2(search: string): any {
    return this.searchedReviewer2.filter((option) =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }

  addReviewer2(event: MatChipInputEvent): void {
    if (!this.reviewerAutocomplete2.isOpen) {
      const value = event.value;

      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDD2.filter((obj) => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDD2 as string[]).push(value);
        }
      }

      event.chipInput!.clear();
      this.searchReviewerCntrl2.setValue(null);
    }
  }

  selectedReviewerEvent2(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD2) {
      let sameValueRow = this.reviewerDD2.filter(
        (obj) => obj === event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.reviewerDD2.push(event.option.viewValue);
      }
    } else {
      this.reviewerDD2 = [];
      this.reviewerDD2.push(event.option.viewValue);
    }
    this.reviewerInput.nativeElement.value = '';
    this.searchReviewerCntrl2.setValue(null);
    this.searchReviewerCntrl2.disable();
    this.searchReviewerCntrl2.enable();
  }

  removeReviewer2(status: string): void {
    const index = (this.reviewerDD2 as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD2 as string[]).splice(index, 1);
    }
  }
  // toggleConfirmation(approval: ConfirmApprove): void {
  //   approval.isConfirmed = !approval.isConfirmed;

  //   if (approval.isConfirmed) {
  //     this.confirmApproval2.push({ approverName: approval.approverName, isConfirmed: true });
  //   } else {
  //     this.confirmApproval2 = this.confirmApproval2.filter(a => a.approverName !== approval.approverName);
  //   }
  // }
  toggleConfirmation(approval: ConfirmApprove): void {
    let currentApprover = this.confirmApproval2.findIndex(a => a.approverName == approval.approverName);
    if (approval.isConfirmed) {
      this.confirmApproval2[currentApprover].isConfirmed = true;
    }
    else {
      this.confirmApproval2[currentApprover].isConfirmed = false;
    }
  }
}
